module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAADKADAAQAAAABAAAADAAAAAATDPpdAAAANklEQVQoFWNgwAL0uj7+xyIMFmLCJYFLfBBqYMTnQXR/XCrjZ0QXA/PxGTIIPU2yk7B6Gp8gANucCWK6qg6gAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/normal.png
// module id = 5NA8
// module chunks = 1